module.exports = __webpack_public_path__ + "static/img/vip-offline-light.f2689aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-welfare/vip-offline-light.png
// module id = h2du
// module chunks = 215